var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"close-on-click-modal":false,"close-on-press-escape":false,"show-close":false,"visible":_vm.visible,"width":"330px"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('auth-form',{attrs:{"title":"登 录"}},[_c('login-form',{on:{"login":_vm.onLogin}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }